import React, { Component } from "react";
import { connect } from "react-redux";
import { func, string } from "prop-types";
// import { Modal } from "react-bootstrap";
import { Lightbox } from "react-modal-image";
import PageContent from "../PageContent";
import BlobPreview from "../BlobPreview";
import {
  retry,
  retryProcessing,
  resetAllRetriesFailed,
  resetingDocumentQualityRetries,
} from "../../logic/actions/documentCapture";
import { go } from "../../logic/actions/navigation";
import { documentsSave } from "../../logic/actions/api/document";
import {
  logEvent,
  STEP_COMPLETED,
  DOCUMENT_CAPTURE_RETRY,
} from "../../logic/eventLogger";
import { PASSPORT } from "../../logic/enums/documentType";
import {
  INSTRUCTIONS_FACE_LIVENESS_3D,
  INSTRUCTIONS_CLR,
  DOCUMENT_CAPTURE_INSTRUCTIONS,
  VERIFY_IDENTITY,
} from "../../logic/enums/pages";
import { SVR3DFL } from "../../logic/enums/livenessTestType";
import { ID_CARD } from "../../logic/enums/documentAspectRatios";
import RoundIcon from "../RoundIcon";
import Icon from "../Icon";
import { drawOutherLines } from "../../logic/drawOutherLines";
import { isMobile } from "../../logic/deviceType";
import { blobToBase64 } from "../../logic/blobToBase64";
import "./style.css";
import { CONNECTION_ISSUES } from "../../logic/enums/errorMessages";

export class PageDocumentCaptureConfirm extends Component {
  static propTypes = {
    retry: func,
    base64CroppedFirstPage: string,
    base64CroppedSecondPage: string,
    documentType: string,
    documentsSave: func,
  };

  constructor(props) {
    super(props);
    this.state = {
      serverProcessingFailed: false,
      imageLoaded: false,
      // showModal: false,
      locationAllowed: undefined,
      zoomDocument: false,
      buttonsDisabled: false,
      error: null,
      message: null,
    };
    this.getBack.bind(this);
    this.submit.bind(this);
  }

  componentDidMount() {
    if (this.props.documentProcessorRetries) {
      this.setState({
        documentProcessorRetries: parseInt(this.props.documentProcessorRetries),
      });
    } else {
      this.setState({ documentProcessorRetries: 3 });
    }
    this.drawOnCanvas();
    window.addEventListener("orientationchange", () => {
      if (this.ctx) {
        this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
        this.drawOnCanvas();
      }
    });
    // this.isLocationAllowed();
  }

  componentDidUpdate(_, prevState) {
    if (
      this.state.zoomDocument !== prevState.zoomDocument &&
      this.state.zoomDocument === false
    )
      setTimeout(() => {
        this.setState({ buttonsDisabled: false });
      }, 100);
  }

  componentWillUnmount() {
    this.props.resetAllRetriesFailed();
    window.removeEventListener("orientationchange", this.drawOnCanvas);
  }

  static getDerivedStateFromProps({
    base64CroppedFirstPage,
    base64CroppedSecondPage,
  }) {
    return {
      base64: base64CroppedSecondPage || base64CroppedFirstPage,
    };
  }

  getBack = () => {
    logEvent(DOCUMENT_CAPTURE_RETRY, { value: this.props.documentType });
    logEvent(
      DOCUMENT_CAPTURE_RETRY + "_" + this.props.documentType.toLowerCase()
    );
    this.props.retry();
    this.props.go(DOCUMENT_CAPTURE_INSTRUCTIONS);

    this.props.base64CroppedSecondPage
      ? this.props.resetingDocumentQualityRetries("back")
      : this.props.resetingDocumentQualityRetries("front");
  };

  // isLocationAllowed = () => {
  //   if (navigator.permissions) {
  //     navigator.permissions.query({ name: "geolocation" }).then((result) => {
  //       if (result.state === "granted") {
  //         this.setState({ locationAllowed: "granted" });
  //       } else if (result.state === "denied") {
  //         this.setState({ locationAllowed: "denied" });
  //       } else {
  //         this.setState({ locationAllowed: "ask" });
  //       }
  //     });
  //   } else {
  //     this.setState({ locationAllowed: "granted" });
  //   }
  // };

  allowedGeolocation = () => {
    this.setState({ locationAllowed: true });
  };

  drawOnCanvas = () => {
    setTimeout(() => {
      const wrapperDiv = document.getElementById("wrapperDiv");
      let offsetHeight, offsetWidth;
      if (this.props.isRejected && isMobile(navigator.userAgent)) {
        offsetHeight = wrapperDiv.offsetWidth;
        offsetWidth = offsetHeight / (1920 / 1080);
      } else if (this.props.documentType === "PASSPORT") {
        offsetWidth = wrapperDiv.offsetWidth;
        offsetHeight = offsetWidth / 1.4205;
      } else {
        offsetWidth = wrapperDiv.offsetWidth;
        offsetHeight = offsetWidth / ID_CARD.aspectRatio;
      }

      this.setState({ offsetWidth, offsetHeight });
      this.img = new Image();
      this.img.src = "data:image/jpeg;base64," + this.state.base64;
      if (this.refs.canvas) {
        const edgeOverlay = 0.05 * offsetWidth;
        this.canvas = this.refs.canvas;
        this.canvas.style.width = offsetWidth;
        this.canvas.style.height = offsetHeight;
        this.ctx = this.canvas.getContext("2d");

        drawOutherLines(
          this.ctx,
          edgeOverlay,
          offsetHeight,
          offsetWidth,
          this.img,
          this.props.allRetriesFailed
        );
      }
    }, 500);
  };
  deniedGeolocation = () => {
    this.setState({ locationAllowed: false });
  };

  // handleShowModal = () => {
  //   // this.isLocationAllowed();
  //   if (
  //     this.props.singlePaged ||
  //     this.props.base64CroppedSecondPage ||
  //     this.props.documentType === PASSPORT
  //   ) this.submit();
  //   //   if (this.state.locationAllowed === "ask" && !this.state.showModal) {
  //   //     this.setState({ showModal: true });
  //   //   } else if (this.state.locationAllowed === "ask" && this.state.showModal) {
  //   //     this.setState({ showModal: false }, this.submit);
  //   //   } else {
  //   //     this.submit();
  //   //   }
  //   // } else {
  //   //   this.submit();
  // };

  showZoomedImage = () => {
    this.state.zoomDocument
      ? this.setState({ zoomDocument: false })
      : this.setState({ zoomDocument: true, buttonsDisabled: true });
  };

  submitUncroppedImages = async () => {
    const uncroppedFirstPage = this.props.blobFirstPage
      ? await blobToBase64(this.props.blobFirstPage)
      : null;
    const uncroppedSecondPage = this.props.blobSecondPage
      ? await blobToBase64(this.props.blobSecondPage)
      : null;

    this.props
      .documentsSave(
        uncroppedFirstPage,
        uncroppedSecondPage,
        this.props.documentType
      )
      .then((response) => {
        if (
          response.processingStatus === "FAILED" &&
          this.props.processingRetriesCounter <
            this.state.documentProcessorRetries
        ) {
          this.setState({
            serverProcessingFailed: true,
            pending: false,
            error: `We could not read your document, please retry capturing - ${
              this.state.documentProcessorRetries -
              this.props.processingRetriesCounter
            } retries left`,
          });
        } else if (response.httpStatus === "400" && response.message) {
          this.setState({
            serverProcessingFailed: true,
            pending: false,
            error: response.message,
          });
        } else {
          logEvent(STEP_COMPLETED, { value: "document_capture" });
          logEvent(STEP_COMPLETED + "_document_capture");
          if (
            this.props.livenessTestData &&
            this.props.livenessTestData.items[0].type === SVR3DFL
          ) {
            this.props.go(INSTRUCTIONS_FACE_LIVENESS_3D);
          } else {
            this.props.go(INSTRUCTIONS_CLR);
          }
        }
      })
      .catch((err) => {
        this.setState({
          error: err
            ? err.toString()
            : CONNECTION_ISSUES,
          pending: false,
        });
      });
  };

  submit = () => {
    this.setState({ pending: true });
    if (
      this.props.documentType === PASSPORT ||
      this.props.base64CroppedSecondPage ||
      this.props.singlePaged === true
    ) {
      this.props
        .documentsSave(
          this.props.base64CroppedFirstPage,
          this.props.base64CroppedSecondPage,
          this.props.documentType
        )
        .then((response) => {
          if (
            response.processingStatus === "FAILED" &&
            this.props.processingRetriesCounter <
              this.state.documentProcessorRetries
          ) {
            if (this.props.isRejected) {
              this.setState({
                serverProcessingFailed: true,
                pending: false,
                error: `We could not read your document, please retry capturing - ${
                  this.state.documentProcessorRetries -
                  this.props.processingRetriesCounter
                } retries left`,
              });
            } else this.submitUncroppedImages();
          } else if (response.httpStatus === "400" && response.message) {
            this.submitUncroppedImages();
          } else {
            logEvent(STEP_COMPLETED, { value: "document_capture" });
            logEvent(STEP_COMPLETED + "_document_capture");
            if (
              this.props.livenessTestData &&
              this.props.livenessTestData.items[0].type === SVR3DFL
            ) {
              this.props.go(INSTRUCTIONS_FACE_LIVENESS_3D);
            } else {
              this.props.go(INSTRUCTIONS_CLR);
            }
          }
        })
        .catch((err) => {
          this.setState({
            error: err && err.name !== "AbortError"
              ? err.toString()
              : CONNECTION_ISSUES,
            pending: false,
          });
        });
    } else {
      this.props.go(DOCUMENT_CAPTURE_INSTRUCTIONS);
    }
  };

  retryCapturing = () => {
    this.props.go(VERIFY_IDENTITY);
    this.props.retryProcessing();

    this.props.base64CroppedSecondPage
      ? this.props.resetingDocumentQualityRetries("back")
      : this.props.resetingDocumentQualityRetries("front");
  };

  render() {
    let text;
    if (this.props.isRejected && !this.props.allRetriesFailed) {
      //is this overcomplicated logic???
      text = "Please retake your document.";
    } else if (!this.props.allRetriesFailed) {
      text =
        "Ensure that the captured document image is fully visible, sharp, and without blur or glare. Make sure that the text is readable before proceeding.";
    } else {
      text =
        "We were unable to check quality of the captured document. If you are still able to clearly see the document in the image, please continue.";
    }
    const classNameBtn = this.state.pending ? "btn gray" : "btn blue";
    // const logicClassNamePart = (isAndroid(navigator.userAgent) && this.props.captureMethod === NATIVE)
    //   ? "rotate-mobile-native" : this.props.captureMethod === WEBRTC
    //     ? "flip-x" : "";
    // const blobPreviewClassName = `img-preview ${logicClassNamePart}`
    return (
      <PageContent
        toggleLoading={this.state.pending}
        progressBar={true}
        progressPercentage={80}
      >
        <h1>Image Captured</h1>

        <div
          id="wrapperDiv"
          // style={{ height: "45vh" }}
          className="panel border-gray bg-row"
        >
          {!this.props.isRejected ? (
            <canvas
              onClick={this.showZoomedImage}
              style={{
                visibility: this.state.buttonsDisabled ? "hidden" : "visible",
              }}
              ref="canvas"
              // style={{ border: "1px solid black" }}
              width={this.state.offsetWidth}
              height={this.state.offsetHeight}
            ></canvas>
          ) : (
            <BlobPreview
              showZoomedImage={this.showZoomedImage}
              disabled={this.state.buttonsDisabled}
              blob={
                this.props.base64CroppedSecondPage ||
                this.props.base64CroppedFirstPage
              }
              width={this.state.offsetWidth}
              height={this.state.offsetHeight}
            />
          )}
          {this.state.zoomDocument && (
            <Lightbox
              medium={this.img.src}
              onClose={this.showZoomedImage}
              hideZoom={true}
              hideDownload={true}
            ></Lightbox>
          )}
        </div>
        <button
          className="btn white button-go-to-login"
          style={{ visibility: this.state.base64 ? "visible" : "hidden" }}
          onClick={this.showZoomedImage}
        >
          View larger
        </button>
        {(this.props.allRetriesFailed || this.props.isRejected) &&
        this.props.summaryScorePresent ? (
          <div className="panel  flex-row">
            <RoundIcon color="yellow">
              <Icon name="Info" color="white" />
            </RoundIcon>
            <div className="panel-content">
              <p>{text}</p>
            </div>
          </div>
        ) : this.props.allRetriesFailed || this.props.isRejected ? (
          <div className="panel  flex-row">
            <RoundIcon color="red">
              <Icon name="Rejected" color="white" />
            </RoundIcon>
            <div className="panel-content">
              <p>{text}</p>
            </div>
          </div>
        ) : (
          <div className="panel  flex-row">
            <RoundIcon color="blue">
              <Icon name="Info" color="white" />
            </RoundIcon>
            <div className="panel-content">
              <p>{text}</p>
            </div>
          </div>
        )}
        <p className="error">{this.state.error}</p>
        <div className="message-box-error">{this.props.message}</div>
        {(!this.props.isRejected || this.props.allRetriesFailed) &&
        !this.state.serverProcessingFailed ? (
          <div>
            <button
              disabled={this.state.buttonsDisabled || this.state.pending}
              className="btn white"
              onClick={this.getBack}
            >
              Take a new picture{" "}
            </button>
            <br />
            <button
              disabled={this.state.buttonsDisabled || this.state.pending}
              className={classNameBtn}
              onClick={this.submit}
            >
              My document is readable
            </button>
          </div>
        ) : this.state.serverProcessingFailed ? (
          <button
            disabled={this.state.buttonsDisabled || this.state.pending}
            className="btn blue"
            onClick={this.retryCapturing}
          >
            Retry capturing
          </button>
        ) : (
          <button
            disabled={this.state.buttonsDisabled || this.state.pending}
            className="btn white"
            onClick={this.getBack}
          >
            Retake the photo
          </button>
        )}
        {/* <Modal
          show={this.state.showModal && this.state.locationAllowed === "ask"}
          onHide={this.handleShowModal}
        >
          <Modal.Header closeButton>
            <Modal.Title></Modal.Title>
            <Modal.Body>
              <p>
                <strong>
                  We will ask you to grant us your location, so we can compare
                  it with where your document was issued
                </strong>
              </p>
            </Modal.Body>
          </Modal.Header>
        </Modal> */}
      </PageContent>
    );
  }
}

export default connect(
  (state) => {
    return {
      ...state.documentCapture,
      ...state.livenessTest,
      ...state.configuration.extraConfig.featureFlags,
    };
  },
  {
    retry,
    documentsSave,
    go,
    retryProcessing,
    resetAllRetriesFailed,
    resetingDocumentQualityRetries,
  }
)(PageDocumentCaptureConfirm);
